import Vue from 'vue'
import features from '@/entities/features'
Vue.prototype.$features = features
